// extracted by mini-css-extract-plugin
export default {"behavior":"behavior__FGOr7XfU","header":"header__csmpPJdo","actions":"actions__RFdnekN1","content":"content__Ez8BZFA9","status":"status__xQmJumYy","icon":"icon__NmtgsKAT"};